<template>
  <el-form-item :label="i18nt('designer.setting.cancelButtonLabel')">
    <el-input type="text" v-model="optionModel.cancelButtonLabel"></el-input>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"
  import propertyMixin from "../propertyMixin"

  export default {
    name: "cancelButtonLabel-editor",
    mixins: [i18n, propertyMixin],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// cancelButtonLabel-editor.vue?74766ca8